import { render } from "./BalanceLimit.vue?vue&type=template&id=577e69a0&scoped=true"
import script from "./BalanceLimit.vue?vue&type=script&lang=js"
export * from "./BalanceLimit.vue?vue&type=script&lang=js"

import "./BalanceLimit.vue?vue&type=style&index=0&id=577e69a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577e69a0"]])

export default __exports__